import './post.scss';
import React from "react";
import Element from '../../basic/element';
import axios from "axios";

export default class Post extends React.Component {
    static defaultProps = {
        type: '',
        category: '',
        label: '',
        apibaseurl: '',
        apiUrl: '',
        querystring: '',
        limit: 4,
        icon: null,
        title: null,
        description: null,
        actions: [],
        entry: {
            by: {
                html: 'by'
            },
            readmore: {
                html: 'Read more'
            }
        },
        loading: null,
        noentry: null
    }
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            entries: []
        };
    }
    componentDidMount() {
        const limit = this.props.limit;
        const category = this.props.category;
        const label = this.props.label;
        const labelPartOfApi = label ? `&label=${label}` : '';
        const queryString = this.props.querystring ? this.props.querystring : `board=${category}${labelPartOfApi}&limit=${limit}`;
        const apiBaseUrl = this.props.apibaseurl ? this.props.apibaseurl : (PubHub.APIHost + '/v1/communities/posts');
        const url = `${apiBaseUrl}?${queryString}`;

        axios.get(this.props.apiUrl || url).then((response) => {
            this.setState({ loading: false, entries: response.data })
        })
    }
    getSafeText(rawText) {
        if (typeof rawText !== 'string') return '';
        return rawText.replace(/<[^>]*>/g, '').trim();
    }
    getSafeUrl(rawUrl) {
        if (typeof rawUrl !== 'string' || !rawUrl.trim()) {
            return null;
        }
        try {
            const parsed = new URL(rawUrl, window.location.origin);
            if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
                return null;
            }
            return parsed.toString();
        } catch (e) {
            return null;
        }
    }
    render() {
        const className = this.buildClassName();
        const header = this.renderHeader();
        const entries = this.renderEntries();
        const actions = this.renderActions();

        return (
            <div id={this.props.id} className={className} style={this.props.style}>
                {header}
                {entries}
                {actions}
            </div>
        );
    }
    renderIcon(data) {
        if (!data) {
            return null;
        }
        if (data.html == 'blog' || data.html == 'discussion') {
            const img = data.html == 'blog' ? 'post-blog.svg' : 'post-disc.svg';
            const imgUrl = `/pubhubsdk/img/${img}`;
            data.html = `<img src='${imgUrl}' />`
        }

        return (<Element className='icon' data={data} />);
    }
    renderHeader() {
        const hasHeader = this.props.icon || this.props.title || this.props.description;

        if (!hasHeader) {
            return;
        }

        const icon = this.renderIcon(this.props.icon);

        return (
            <div className='header'>
                <div className='container'>
                    {icon}
                    <Element className='title' data={this.props.title} />
                    <Element className='description' data={this.props.description} />
                </div>
            </div>
        );
    }
    renderEntries() {
        if (this.state.loading) {
            const loading = this.props.loading ? this.props.loading : { html: "<div class='pubhub-loading'></div>" };
            return this.renderUnusual('loading-indicator', loading);
        }

        if (!this.state.entries || this.state.entries.length == 0) {
            return this.renderUnusual('empty-indicator', this.props.noentry || 'No entry');
        }

        const entryList = this.state.entries.map((i) => this.renderEntry(i));

        return (
            <div className='entries'>
                <div className='container'>
                    <Element className='entries-title' data={this.props.subtitle} />
                    <div className='row entries-row'>
                        {entryList}
                    </div>
                </div>
            </div>
        );
    }
    renderEntry(entry) {
        const entryConfig = this.props.entry;
        const time = this.formatDate(entry.modified);
        const type = entryConfig.type ? entryConfig.type : (this.props.type == 'blog' ? 'blog' : '');
        const safeTitleText = this.getSafeText(entry.title);
        const safeEntryLink = this.getSafeUrl(entry.link);
        const safeAuthorLink = this.getSafeUrl(entry.author && entry.author.link);

        return (
            <div key={entry.id} className='col col-12 col-md-6 entry-col'>
                <div className='entry'>
                    <Element className='entry-type' data={type} />
                    {safeEntryLink
                        ? <a href={safeEntryLink} target='_blank' rel="noopener noreferrer" className='entry-title'>{safeTitleText}</a>
                        : <span className='entry-title'>{safeTitleText}</span>}
                    <div className='entry-info'>
                        <Element tagName='span' className='entry-by' data={entryConfig.by} />
                        {safeAuthorLink
                            ? <a className='entry-author' href={safeAuthorLink} target='_blank' rel="noopener noreferrer">{entry.author.name}</a>
                            : <span className='entry-author'>{entry.author && entry.author.name}</span>}
                        <span className="entry-info-splitter">|</span>
                        <span className='entry-time'>{time}</span>
                    </div>
                    <Element className='entry-content' data={entry.content + "..."} />
                    {safeEntryLink
                        ? <a href={safeEntryLink} target='_blank' rel="noopener noreferrer">
                            <Element className='entry-readmore' data={entryConfig.readmore} />
                        </a>
                        : <Element className='entry-readmore' data={entryConfig.readmore} />}
                </div>
            </div>
        );
    }
    renderActions() {
        const category = this.props.category;
        const label = this.props.label;
        const labelPartOfApi = label ? `&labels=${label}` : '';
        const viewAllHref = `https://community.cisco.com/t5/custom/page/page-id/CustomFilteredByMultiLabel/page/1?board=${category}${labelPartOfApi}`;
        if (!this.props.actions || this.props.actions.length == 0) {
            return null;
        }
        const actions = this.props.actions.map((i, index) => {
            const data = i.href ? Object.assign({}, i, { target: i.target || '_blank' }) : Object.assign({}, i, { href: viewAllHref, target: i.target || '_blank' });
            return <Element key={index} className='action btn btn-primary btn-lg-wide' data={data} />
        });

        const className = this.state.entries.length > 0 ? ' show' : '';

        return (
            <div className={'actions' + className}>
                <div className='container'>
                    {actions}
                </div>
            </div>
        );
    }
    renderUnusual(className, data) {
        return (
            <div className='entries'>
                <div className='container'>
                    <Element className={className} data={data} />
                </div>
            </div>
        );
    }
    buildClassName() {
        return [
            'pubhub-community-post pubhub-widget',
            this.props.className || (this.props.type == 'blog' ? 'card-entry' : ''),
            this.state.loading ? 'loading' : '',
            'count-' + this.state.entries.length,
            this.state.entries.length < this.props.limit ? 'less-entries' : '',
            'type-' + this.props.type
        ].filter((i) => i).join(' ');
    }
    formatDate(str) {
        if (!str) {
            return '';
        }

        const MaxLength = 19;//'2018-07-27T13:25:30'.length;
        const date = str.length > MaxLength ? new Date(str.substr(0, MaxLength)) : new Date(str);
        return date.toLocaleDateString();
    }
}